import Profile from '../components/Profile';

export default Profile;